/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import axiosInstance from '../../../../../services/AxiosInstance';
import ExcelImport from '../../../../../components/ExcelImport';
import InputField from '../../../../../components/InputField';
import TableAddForm from '../../../../../components/TableAddForm';
import ReactPaginate from 'react-paginate';
import ScheduleInterview from './ScheduleInterview';

const PostJobTable = ({
    url,
    column,
    filters = '',
    header = [],
    title = '',
    addform = {},
    goback,
    view,
    approve,
    excelheader,
    excelurl,
    extraKey,
    status = ["Approved"],
    viewIcon = 'Click here to view the record',
    PJedit,
    edit = true,
    recDelete = true,
    makePayment = false,
    finish = false,
    subuser
}) => {

    const [modal, setModal] = useState(false);
    const [data, setData] = useState([]);
    const [excelImport, setexcelImport] = useState(false);
    const [pagination, setPagination] = useState();
    const [input, setInput] = useState({});
    const [finishData, setFinishData] = useState({ finish_reason: "" });
    const [showSuccess, setShowSuccess] = useState(false);
    const [finishModal, setFinishModal] = useState({ show: false });
    const [interviewModal, setInterviewModal] = useState(false);

    useEffect(() => {
        getData();
    }, [url]);

    const getData = (page = 1) => {
        axiosInstance(
            `${url}?${filters}&page=${page}`, { method: "GET" }
        ).then(res => {
            let results = res?.data?.results;
            setData(
                results.map(result => {
                    return {
                        ...result,
                        select: false
                    }
                })
            );
            setPagination(res?.data?.pagination)
        })
            .catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }


    const handleDelete = (id) => {
        setShowSuccess(false);
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete this record?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    axiosInstance(`${url}/?delete_ids=${id}`, { method: "DELETE" })
                        .then(res => {
                            if (res?.status === 204) {
                                getData();
                                swal("", "Deleted Successfully", "success", { button: "Ok!", })
                            }
                        })
                        .catch(err => swal("", err?.response?.data?.detail, { button: "Ok!", }))
                }
            });
    }

    const handleApprove = (id) => {
        axiosInstance(`${url}/${id}/`, { method: "PATCH", data: { "status": approve } })
            .then(res => {
                if (res.status === 200) {
                    getData();
                    swal("", "Candidate status updated", "success", { button: "Ok!", })
                }
            }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }

    const handleCloseExport = () => {
        setexcelImport(!excelImport);
        getData();
    }

    const handleEdit = (id) => {
        var editurl = subuser ? `${subuser}${id}/` : `${url}/${id}/`;
        axiosInstance(editurl, { method: 'GET' }).then(res => {
            if (subuser) setInput(res.data?.[0]);
            else setInput(res.data);
            setModal(true);
        }).then(err => {
            console.log(err);
        })
    }

    const handlePayment = (id, amount, symbol) => {
        swal({
            title: `${symbol} ${amount}`,
            text: "Are you sure that you want to make payment?",
            icon: "info",
        })
            .then(onOk => {
                if (onOk) axiosInstance('payment/', { method: 'post', data: { "job": id, "amount": amount } })
                    .then(res => {
                        if (res.status === 200) window.location.href = res.data.payment_url;
                    }).catch(err => {
                        swal("", Object.values(err?.response?.data).join(', '), "error", { button: "Ok!", });
                    })
            });
    }

    const handleChange = (e) => {
        setFinishData({ ...finishData, [e.target.name]: e.target.value });
    }

    const handleFinish = (id, vacancies) => {
        axiosInstance(
            `can-applyjob/?job=${id}`, { method: "GET" }
        ).then(res => {
            if (res.data?.results?.length === vacancies) {
                swal({
                    title: "Are you sure?",
                    text: "Are you sure that you want to Finish this job?",
                    icon: "warning",
                    dangerMode: true,
                }).then(willDelete => {
                    if (willDelete) {
                        axiosInstance(
                            `${url}/${id}/`, {
                            method: "PATCH",
                            data: { job_status: "f" }
                        }).then(res => {
                            swal("", "Job Finished Successfully", "success", { button: "Ok!", })
                            getData();
                        }).catch(err => {
                            swal("", Object.values(err?.response?.data).join(', '), "error", { button: "Ok!", });
                        })
                    }
                });

            } else {
                setFinishModal({ show: true, id: id });
            }
        })
    }

    const handleFinishPost = () => {
        axiosInstance(
            `${url}/${finishModal?.id}/`, {
            method: "PATCH",
            data: { job_status: "f", finish_reason: finishData?.finish_reason }
        }).then(res => {
            swal("", "Job Finished Successfully", "success", { button: "Ok!", })
            getData();
        }).catch(err => {
            swal("", Object.values(err?.response?.data).join(', '), "error", { button: "Ok!", });
        })
        setFinishModal({ ...finishModal, show: false });
    }

    const handleInput = (e, name) => {
        setInput({ ...input, [name]: e });
    }

    const handleInterviewSchedule = () => {
        let profiles = [];
        data.filter(can => can.select).forEach(can => {
            profiles.push(can.id);
        })
        axiosInstance('can-applyjob/bulk-schedule/', {
            method: "PATCH", data: {
                "workflow": input.interview_type.id,
                "interview_time": input.interview_time,
                "ids": profiles
            }
        }).then(res => {
            if (res.status === 200) {
                swal("", "Interview Scheduled for the selected Candidates", "success", { button: "Ok!", });
                getData();
            }
        }).catch(err => swal("", err?.response?.data?.error || "Error", "error", { button: "Ok!", }))
        setInterviewModal(false);
    }

    return (
        <>
            {
                modal &&
                <TableAddForm
                    setModal={setModal}
                    title={title}
                    input={input}
                    setInput={setInput}
                    addform={addform}
                    url={url}
                    setShowSuccess={setShowSuccess}
                    extraKey={extraKey}
                    getData={getData}
                    subuser={subuser}
                />
            }
            {
                interviewModal &&
                <ScheduleInterview
                    setModal={setInterviewModal}
                    modal={interviewModal}
                    input={input}
                    handleInput={handleInput}
                    handleSubmit={handleInterviewSchedule}
                />
            }
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white p-b20">
                        <div className="container">
                            <div className="job-bx browse-job clearfix">
                                <div className="job-bx-title  clearfix">
                                    <h5 className="font-weight-700 pull-left text-uppercase">{title}</h5>
                                    {
                                        Object.keys(addform).length > 0 &&
                                        <div className="float-right">
                                            <button
                                                className="btn btn-primary ml-3"
                                                onClick={() => ((setModal(true), setShowSuccess(false)))}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    }
                                    {
                                        data.filter(item => item.select).length > 0 &&
                                        <Link to={"#"} className="site-button button-sm float-right ml-2" onClick={() => setInterviewModal(true)}>Schedule Interview</Link>
                                    }
                                    {
                                        goback &&
                                        <Link to={goback} className="site-button right-arrow button-sm float-right">Back</Link>
                                    }
                                    <div className="float-right">
                                        {
                                            excelheader?.length > 0 &&
                                            <span
                                                className="float-right pointer text-primary"
                                                onClick={() => handleCloseExport()}
                                            >
                                                {excelImport ?
                                                    <i className="fa fa-arrow-left"> Go to Table</i>
                                                    : <i className="fa fa-upload"> Import</i>}
                                            </span>
                                        }

                                    </div>
                                    <div className="float-right">
                                        <span className="select-title"></span>
                                    </div>
                                </div>
                                {
                                    excelImport ?
                                        <ExcelImport
                                            headers={excelheader}
                                            url={excelurl}
                                        />
                                        :
                                        <>
                                            {showSuccess && <span className="text-danger font-weight-bold">Added Successfully</span>}
                                            <div className="table-resposive template-table">
                                                <table className="table-job-bx cv-manager company-manage-job">
                                                    <thead>
                                                        <tr className="text-center">
                                                            <th className="feature">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e) => {
                                                                        let checked = e.target.checked;
                                                                        setData(data.map(d => {
                                                                            d.select = checked;
                                                                            return d;
                                                                        }))
                                                                    }}
                                                                />
                                                            </th>
                                                            <th className="feature">##</th>
                                                            {
                                                                header?.map(res => {
                                                                    return (
                                                                        <th key={res}>{res}</th>
                                                                    )
                                                                })
                                                            }
                                                            <th className="feature text-center p-0">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            <>
                                                                {
                                                                    data.length > 0 &&
                                                                    data?.map((res, i) => {
                                                                        var id = +`${pagination?.currentPage - 1}0`
                                                                        return (
                                                                            <tr key={`${res.id}tr`}>
                                                                                <td>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={res?.select}
                                                                                        onChange={(e) => {
                                                                                            let checked = e.target.checked;
                                                                                            setData(data.map(d => {
                                                                                                if (res.id === d.id) {
                                                                                                    d.select = checked;
                                                                                                }
                                                                                                return d;
                                                                                            }))
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td className="feature" key={id + i + 1}>{id + i + 1}</td>
                                                                                {
                                                                                    column.map(col => {
                                                                                        let data;
                                                                                        if (typeof res[col] === "boolean") {
                                                                                            data = res[col] ?
                                                                                                <i className="fa fa-check" style={{ fontSize: "25px", color: "green" }} />
                                                                                                : <i className="fa fa-close" style={{ fontSize: "25px", color: "red" }} />;
                                                                                        } else if (Array.isArray(col)) {
                                                                                            data = res[col[0]]?.[col[1]]
                                                                                        }
                                                                                        else { data = res[col] }
                                                                                        return <td align={typeof data === 'number' ? 'center' : 'left'}>{data}</td>
                                                                                    })
                                                                                }
                                                                                <td className="job-links pr-0" key="viewicon" style={{ display: "flow-root" }}>
                                                                                    {view &&
                                                                                        <Link to={`${view}/${res.id}`}>
                                                                                            <i className="fa fa-eye" title={viewIcon} />
                                                                                        </Link>
                                                                                    }
                                                                                    {
                                                                                        recDelete && !(status.includes(res?.job_status)) &&
                                                                                        <span onClick={() => handleDelete(res.id)}>
                                                                                            <i className="ti-trash" title='Click here to delete the record' style={{ cursor: "pointer" }} />
                                                                                        </span>
                                                                                    }
                                                                                    {
                                                                                        PJedit && !(status.includes(res?.job_status)) &&
                                                                                        <Link to={`company-post-jobs/${res.id}`}>
                                                                                            <span>
                                                                                                <i className="ti-pencil" title='Click here to edit the record' style={{ cursor: "pointer" }} />
                                                                                            </span>
                                                                                        </Link>
                                                                                    }
                                                                                    {
                                                                                        edit &&
                                                                                        <span onClick={() => handleEdit(res.id)}>
                                                                                            <i className="ti-pencil" title='Click here to edit the record' style={{ cursor: "pointer" }} />
                                                                                        </span>
                                                                                    }
                                                                                    {
                                                                                        approve && !(status.includes(res?.status)) &&
                                                                                        <span onClick={() => handleApprove(res.id)} >
                                                                                            <i className="fa fa-check" title='Click here to approve' style={{ cursor: "pointer" }} />
                                                                                        </span>
                                                                                    }
                                                                                    {
                                                                                        finish && !(status.includes(res?.job_status)) &&
                                                                                        <span onClick={() => handleFinish(res.id, res.vacancies)} >
                                                                                            <i className="ti-close" title='Click here to finish the record' style={{ cursor: "pointer" }} />
                                                                                        </span>
                                                                                    }
                                                                                    {
                                                                                        makePayment && (res.job_status === 'Accepted') &&
                                                                                        <span onClick={() => handlePayment(res.id, res.amount, res?.country?.symbol)} >
                                                                                            <i className="fa fa-cc-visa" title={`Click here to Pay ${res?.amount}`} style={{ cursor: "pointer" }} />
                                                                                        </span>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        )

                                                                    })}
                                                                {
                                                                    data.length === 0 &&
                                                                    <tr>
                                                                        <td colSpan={column.length + 2}>
                                                                            <div className="alert alert-danger">
                                                                                <h5 className="text-center">No Data Found</h5>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="m-t10">
                                                <ReactPaginate
                                                    nextLabel="Next >"
                                                    onPageChange={e => getData(e.selected + 1)}
                                                    pageRangeDisplayed={3}
                                                    marginPagesDisplayed={2}
                                                    pageCount={pagination?.totalPages}
                                                    previousLabel="< Prev"
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    previousClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    nextClassName="page-item"
                                                    nextLinkClassName="page-link"
                                                    breakLabel="..."
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    containerClassName="pagination float-right"
                                                    activeClassName="active"
                                                    renderOnZeroPageCount={null}
                                                />
                                            </div>
                                        </>
                                }
                                {
                                    finishModal &&
                                    <Modal className="modal fade modal-bx-info editor" show={finishModal?.show} onHide={setFinishModal}>
                                        <div className="my-0" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="EducationModalLongTitle">Reason for finishing this job</h5>
                                                    <button type="button" className="close" onClick={() => setFinishModal({ show: false })}>
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12">
                                                            <div className="form-group">
                                                                <InputField
                                                                    label="Reason (You have not yet received enough candidates)"
                                                                    name="finish_reason"
                                                                    textType='textarea'
                                                                    value={input?.finish_reason}
                                                                    onChange={(e) => handleChange(e)}
                                                                    required={true}
                                                                    placeholder="Enter Reason"
                                                                />
                                                                {
                                                                    finishModal?.error === true &&
                                                                    <span className="text-danger">
                                                                        Please Enter reason
                                                                    </span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="site-button" onClick={() => setFinishModal({ show: false })}>Cancel</button>
                                                    <button
                                                        type="button"
                                                        className="site-button"
                                                        onClick={() => handleFinishPost()}
                                                        disabled={finishData?.finish_reason !== "" ? false : true}
                                                        style={{ backgroundColor: finishData?.finish_reason !== "" ? "#1d46f5" : "#8b99d5", cursor: finishData?.finish_reason !== "" ? "pointer" : "not-allowed" }}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PostJobTable;